import { CourseRun } from "@/common/courseRun/types";
import {
  getI18nDateContextualString,
  getI18nDateString,
  getI18nDayMonthString,
  isEndingWithinThisYear,
} from "@/lib/date";
import type { CourseInfoTranslate } from "./getCourseInformation";

const getCourseRunTileSecondaryText = (
  { isEnrollable, end }: CourseRun,
  t: CourseInfoTranslate,
) => {
  if (!end) {
    return null;
  }
  const courseRunEndDate = new Date(end);
  if (isEnrollable && courseRunEndDate > new Date()) {
    const endDate = isEndingWithinThisYear(courseRunEndDate)
      ? // courses with end dates within the next calendar year drop the year
        getI18nDayMonthString(courseRunEndDate)
      : getI18nDateString(courseRunEndDate);
    return t("endsDate", { date: endDate });
  }
  return null;
};

export const getCourseRunEndText = (
  { isEnrollable, end }: CourseRun,
  t: CourseInfoTranslate,
) => {
  if (!end) {
    return null;
  }
  const courseRunEndDate = new Date(end);
  if (isEnrollable && courseRunEndDate > new Date()) {
    const endDate = getI18nDateContextualString(courseRunEndDate);
    return t("endsDate", { date: endDate });
  }
  // Archived runs (!isEnrollable) and enrollable runs past their end date
  const endDate = getI18nDateContextualString(courseRunEndDate);
  return t("endedDate", { date: endDate });
};

export default getCourseRunTileSecondaryText;
